import { render, staticRenderFns } from "./detailDevice.vue?vue&type=template&id=c3601396&scoped=true"
import script from "./detailDevice.vue?vue&type=script&lang=js"
export * from "./detailDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3601396",
  null
  
)

export default component.exports